import * as R from 'ramda'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { notifications, comments, properties } from './entities'
import { makePropSelector, makeRefSelector, currentUser, doc, db } from './common'

export let currentUserNotifications = createSelector(
	[currentUser, notifications]
  , (currentUser, notifications) => R.filter(x => x.to == currentUser, notifications)
)

export let currentUserOpenNotifications = createSelector(
	[currentUserNotifications, db, currentUser]
  , (currentUserNotifications, db, currentUser) => {
		return R.filter(x => !x.done && ((x.commentID && db[x.commentID] && db[db[x.commentID].objectID])) && x.from !== currentUser, currentUserNotifications)
	}
)

export let commentNotifications = createSelector(
	[notifications, makePropSelector('commentID')]
  , (notifications, commentID) => R.filter(x => x.commentID == commentID, notifications)
)

export let notificationComment = createSelector(
	[comments, doc]
  , (comments, doc) => comments[doc.commentID]
  , 'notificationComment'
)

export let notificationObject = (state, notificationID) => (
	doc(state, makeRefSelector("commentID")(state, notificationID).objectID)
)

//TODO check notificationsByPropertyID
export let notificationsByPropertyID = createSelector([notifications, properties, db],
	(notifications, properties, db)=>{

		let notificationsEx = R.map((notification)=>{
			let comment = db[notification.commentID]
			if (!comment) {
				console.log(notification);
				return
			}
			let objectID = comment.objectID;
			let notificationObject = db[objectID];
			if (!notificationObject){
			}
			if(notificationObject.type == 'application') {console.log(notificationObject);}
			if(notificationObject.type == 'task') notificationObject.projectName = db[notificationObject.projectID].title
			//if(notificationObject.type == 'application') notificationObject.rent = db[notificationObject.listingID].rent
			let object = notificationObject || {}
			if (!object) return false
			let propertyID= object.type == 'term' ?
				db[object.parentID].propertyID
				:
				object.type == 'task' ?
					db[object.projectID].propertyID
					:
					object.type == 'property' ?
						object._id
						:
						object.propertyID
			return {...notification, propertyID, objectID, comment, object: notificationObject, property: db[propertyID] && db[propertyID].alias}
		})(notifications)

		return notificationsEx
})

// TODO check
export let notificationsGroups = createSelector([notificationsByPropertyID, makePropSelector('objectID'), currentUser],
	(notifications, propertyID, currentUser)=>{
		let notificationsEx = R.filter(x=>x)(notifications)
		let notificationsByPropertyID = R.groupBy(R.prop('propertyID'))(notificationsEx)
		let group;
		let counter=0;
		if (propertyID=="all"){
			group = notificationsEx || [];
		}else{
			group = notificationsByPropertyID[propertyID] || [];
		}
		R.forEach((notification)=>{if(!notification.read && currentUser!=notification.from) counter++})(group);
		let notificationsByObjectID = R.pipe(R.sortBy(R.prop('createdAt')), R.reverse, R.groupBy(R.prop('objectID')))(group)
		return {notifications: notificationsByObjectID, counter}
})

export let unreadedNotifications = createSelector([currentUserOpenNotifications],  (notifications) => R.filter(x => !x.read, notifications))



// WEBPACK FOOTER //
// ./src/selectors/notifications.js